<template>
    <answers ref="answers"
             code_question_group="GQ15"
             danger_code="MCAL37"
             @ready="setAnswers({question_group: question_groups[0]})"
    >
        <template slot="QCAL128"
                  slot-scope="data"
        >
            {{ data.data.question }}

            <el-popover placement="left"
                        title="Advertencia"
                        width="350"
                        trigger="click"
                        popper-class="custom-popover"
            >
                <div>
                    Advertencia
                    Por favor, tenga en cuenta que el Protocolo de Montreal incluye componentes que no tienen un número
                    CAS. Los cuales pertenecen al Anexo C, grupo II y son:
                    <ul class="mt-2">
                        <li>PENTABROMODIFLUOROPROPANO</li>
                        <li>TETRABROMOTRIFLUOROPROPANO</li>
                        <li>PENTABROMOFLUOROPROPANO</li>
                        <li>TETRABROMOFLUOROPROPANO</li>
                    </ul>
                    Esto significa que el sistema no puede identificar automáticamente dichos componentes. Es importante
                    que verifique manualmente si alguno de los componentes de su producto está en la lista y seleccione
                    Si en caso de estar listado.
                </div>

                <span slot="reference"
                      style="cursor: pointer"
                      class="font-weight-bold text-warning text-nowrap"
                >
                    <i class="fa fa-info-circle text-warning ml-3"/> Advertencia
                </span>
            </el-popover>


            <div v-if="show_components_montreal.length > 0"
                 class="small text-success mt-2"
            >
                <span class="font-weight-bold"> Componentes</span>
                <div v-for="c in show_components_montreal">
                    {{ c.cas_number }} - {{ c.name }}
                </div>


            </div>
        </template>
    </answers>
</template>

<script>
import {mapMutations, mapState, mapActions} from 'vuex';
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    data() {
        return {
            show_components_montreal: []
        };
    },
    components: {
        answers
    },
    computed: {
        ...mapState('calculator', [
            'question_groups',
            'components_iarc',
            'product',
            'grouped_components'
        ])
    },
    async mounted() {
        await this.getGroupedComponents();
    },
    methods: {
        ...mapActions('calculator', [
            'getComponentsListedInMontrealProtocol',
            'getGroupedComponents'
        ]),
        async setAnswers({question_group}) {
            const product_id = this.$route.params.product_id;
            const company_id = this.$route.params.company_id;

            this.show_components_montreal = await this.getComponentsListedInMontrealProtocol({product_id, company_id});

            let questions = question_group.questions;

            let question = questions.find(q => q.code === 'QCAL128');

            if (question) {
                let answer = false;

                this.grouped_components.map(c => {
                    this.show_components_montreal.map(cm => {
                        if (!answer && cm.cas_number === c.cas_number){
                            answer = true;
                        }
                    })
                });

                question.answer = answer;

                if (answer) {
                    this.$refs.answers.classify(question.danger_class.code, question.category, question.sga_categories, question.sub_category);
                }
            }
        }
    }
};
</script>
